/* eslint-disable camelcase */
import { createMuiTheme } from '@material-ui/core/styles';
import {
  primaryLight,
  primary1000,
  primary100,
  primaryHoverBG,
  primaryPressedBG,
  accentTwo1000,
  primaryCTAHoverBG,
  primaryCTAPressedBG,
  secondary0,
  secondary50,
  secondary100,
  secondary200,
  secondary300,
  secondary400,
  secondaryHoverBG,
  secondaryPressedBG,
  secondary800,
  secondary900,
  secondary1000,
  secondary1000alpha,
  secondaryBG,
  secondaryText,
  accentThree1000,
  accentThree800,
  accentThree200,
  accentThree100,
  accent3HoverBG,
  accent3PressedBG,
  deleteHoverBG,
  deletePressedBG,
  disabledText,
  disabledBG,
  disabledLight,
  interested,
  uncategorized,
  notInterested,
  notNow,
  blacklisted,
  sponsorship,
  backdrop,
  bounced,
  markAsFinished,
  deliveryStatusBadge,
  erroredBadge,
  completedBadge,
  activeBadge,
  inactiveBadge,
  inactiveText,
  primaryText,
  grey600,
  timelineStepRow,
} from './colors';

export const overridings = {
  name: 'Light Theme',
  palette: {
    white: secondary0,
    transparent: 'transparent',
    backdrop,
    gray: {
      light: disabledLight,
      contrastText: disabledText,
      main: disabledBG,
      dark: secondary900,
      text: inactiveText,
    },
    primary: {
      light: primaryLight,
      loader: `${primary1000} !important`,
      contrastText: secondary0,
      main: primary1000,
      dark: primaryHoverBG,
      darkest: primaryPressedBG,
      100: primary100,
      text: primaryText,
    },
    secondary: {
      loader: `${primary1000} !important`,
      text: secondaryText,
      main: primary1000,
      contrastText: primary1000,
      dark: secondaryHoverBG,
      darkest: secondaryPressedBG,
      light: secondary1000alpha,
      background: secondaryBG,
      1000: secondary1000,
      900: secondary900,
      800: secondary800,
      400: secondary400,
      300: secondary300,
      200: secondary200,
      100: secondary100,
      50: secondary50,
      0: secondary0,
    },
    grey: {
      600: grey600,
    },
    blue: {
      100: timelineStepRow,
    },
    primaryCTA: {
      loader: `${accentTwo1000} !important`,
      main: accentTwo1000,
      contrastText: secondary0,
      dark: primaryCTAHoverBG,
      darkest: primaryCTAPressedBG,
    },
    expandButton: {
      loader: `${accentTwo1000} !important`,
      main: accentTwo1000,
      contrastText: secondary0,
      dark: primaryCTAHoverBG,
      darkest: primaryCTAPressedBG,
    },
    accent3: {
      loader: `${accent3PressedBG} !important`,
      main: accentThree1000,
      contrastText: secondary0,
      dark: accent3HoverBG,
      darkest: accent3PressedBG,
      800: accentThree800,
      200: accentThree200,
      100: accentThree100,
    },
    accent2: {
      1000: accentTwo1000,
    },
    delete: {
      loader: `${accent3PressedBG} !important`,
      main: disabledLight,
      contrastText: accentThree1000,
      dark: deleteHoverBG,
      darkest: deletePressedBG,
    },
    interested,
    uncategorized,
    notInterested,
    notNow,
    bounced,
    markAsFinished,
    blacklisted,
    sponsorship,
    autoReply: '#00c896',
    deliveryStatusBadge,
    erroredBadge,
    completedBadge,
    activeBadge,
    inactiveBadge,
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
  shadows: [
    '0 2px 6px rgba(19, 45, 58, 0.12)',
    '0 4px 10px rgba(19, 45, 58, 0.1)',
    '0 6px 20px rgba(19, 45, 58, 0.08)',
    '0 8px 26px rgba(19, 45, 58, 0.06)',
  ],
};

export default createMuiTheme(overridings);
